import { memo } from "react";
import { css } from "../../../../styled-system/css";
import base from "../../../assets/base/icon.png";
import demo from "../../../assets/demo/icon.png";
import hokkaidoBanner from "../../../assets/hokkaido/banner.jpg";
import kyotoKyoto from "../../../assets/kyoto-kyoto/icon-small.webp";
import marumori from "../../../assets/marumori/card-small.webp";
import miyagi from "../../../assets/miyagi/icon-small.webp";
import type { TenantWithFeature } from "../../../libs/connect";
import { t } from "../../../libs/i18n";

type CardHeaderProps = {
  tenant: TenantWithFeature;
};

export const CardHeader = memo(({ tenant }: CardHeaderProps) => {
  if (tenant.slug === "miyagi") {
    return (
      <div
        className={css({
          bg: "#355076",
          roundedTop: "xl",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: "6px",
        })}
      >
        <img
          src={miyagi}
          alt="logo"
          className={css({
            width: "80px",
            height: "80px",
          })}
        />
      </div>
    );
  }
  if (tenant.slug === "marumori") {
    return (
      <div
        className={css({
          bg: "#FFF5D9",
          roundedTop: "xl",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: "6px",
        })}
      >
        <img
          src={marumori}
          alt="logo"
          className={css({
            height: "64px",
          })}
        />
      </div>
    );
  }
  if (tenant.slug === "demo") {
    return (
      <div
        className={css({
          bg: "#ffc76d",
          roundedTop: "xl",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: "6px",
        })}
      >
        <img
          src={demo}
          alt="logo"
          className={css({
            height: "64px",
          })}
        />
      </div>
    );
  }
  if (tenant.slug === "hokkaido") {
    return (
      <img
        src={hokkaidoBanner}
        alt={t("どうみんポイント")}
        className={css({
          display: "block",
          w: "full",
          roundedTop: "xl",
        })}
      />
    );
  }
  if (tenant.slug === "kyoto-kyoto") {
    return (
      <div
        className={css({
          bg: "#462A61",
          roundedTop: "xl",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: "6px",
        })}
      >
        <img
          src={kyotoKyoto}
          alt="logo"
          className={css({
            height: "64px",
          })}
        />
      </div>
    );
  }
  if (tenant.slug === "shiga-otsu") {
    return (
      <div
        className={css({
          bg: "#ffc76d",
          roundedTop: "xl",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: "6px",
        })}
      >
        <img
          src={base}
          alt="logo"
          className={css({
            height: "64px",
          })}
        />
      </div>
    );
  }
  // TODO: 正式なロゴ・配色が決まったら Figma から取得して差し替える（暫定で base アイコンを流用）
  if (tenant.slug === "shiga-otsu-pay") {
    return (
      <div
        className={css({
          bg: "#ffc76d",
          roundedTop: "xl",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: "6px",
        })}
      >
        <img
          src={base}
          alt="logo"
          className={css({
            height: "64px",
          })}
        />
      </div>
    );
  }
  return null;
});
